import http from "../core/http";
const group = 'lapstart';

export const getStatusRequest = async (data) => {
    return await http.post(`${group}/status`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getSettingsRequest = async (data) => {
    return await http.post(`${group}/settings/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const saveSettingsRequest = async (data) => {
    return await http.post(`${group}/settings/save`, data).then(res => res.data).catch(http.defaultCatch);
}

// Runs inline on the API -- a full roster is four requests to LapStart, so this
// can take a few seconds on a large event. The caller shows a spinner.
export const syncRequest = async (data) => {
    return await http.post(`${group}/sync`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getLogsRequest = async (data) => {
    return await http.post(`${group}/logs/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getPendingDeletionsRequest = async (data) => {
    return await http.post(`${group}/pendingDeletions/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const finalizeRequest = async (data) => {
    return await http.post(`${group}/finalize`, data).then(res => res.data).catch(http.defaultCatch);
}

export const unfinalizeRequest = async (data) => {
    return await http.post(`${group}/unfinalize`, data).then(res => res.data).catch(http.defaultCatch);
}
